'use client'

import { useEffect } from 'react'

export default function LayoutWrap({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    function updateAppHeight() {
      const viewportHeight = window.innerHeight
      document.documentElement.style.setProperty('--app-height', `${viewportHeight}px`)
    }

    updateAppHeight()

    window.addEventListener('resize', updateAppHeight)
    return () => {
      window.removeEventListener('resize', updateAppHeight)
    }
  }, [])

  return <div className="layout-wrap">{children}</div>
}
